"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Icon = _interopRequireDefault(require("@material-ui/core/Icon"));
var _styles = require("@material-ui/core/styles");
var _Hidden = _interopRequireDefault(require("@material-ui/core/Hidden"));
var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _Menu = _interopRequireDefault(require("@material-ui/core/Menu"));
var _AnalyticsWrapper = _interopRequireDefault(require("../Analytics/AnalyticsWrapper"));
var _customClassName = _interopRequireDefault(require("../../../Utils/customClassName"));
var _i18n = require("../../../../Framework/i18n");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var styles = function styles(theme) {
  return {
    iconHover: {
      margin: theme.spacing(1),
      textAlign: 'center',
      verticalAlign: 'middle',
      lineHeight: '24px',
      width: '24px',
      height: '24px',
      '&:hover': {
        color: 'rgba(0,0,0, 0.5)',
        cursor: 'pointer'
      }
    },
    root: {
      whiteSpace: 'nowrap'
    },
    ToolbarButton: {
      padding: 0
    },
    ToolbarIconButton: {
      height: 32,
      width: 32,
      padding: 8,
      '& span': {
        fontSize: 24,
        color: theme.palette.primary.darkText
      }
    },
    MenuItemOption: {
      '@media (hover: none) , (pointer: coarse)': {
        '&:focus': {
          backgroundColor: '#fff'
        }
      }
    },
    toolTitle: {
      alignSelf: 'center',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      width: 175
    }
  };
};
var ITEM_HEIGHT = 52;
var ToolbarList = /*#__PURE__*/function (_React$Component) {
  _inherits(ToolbarList, _React$Component);
  var _super = _createSuper(ToolbarList);
  function ToolbarList() {
    var _this;
    _classCallCheck(this, ToolbarList);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      anchorEl: null
    });
    _defineProperty(_assertThisInitialized(_this), "handleClick", function (event) {
      _this.setState({
        anchorEl: event.currentTarget
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleClose", function () {
      _this.setState({
        anchorEl: null
      });
    });
    return _this;
  }
  _createClass(ToolbarList, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        classes = _this$props.classes,
        tools = _this$props.tools;
      var anchorEl = this.state.anchorEl;
      var open = Boolean(anchorEl);
      var toolbarMobileIcon = !open ? 'menu' : 'close';
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _clsx["default"])(classes.root, (0, _customClassName["default"])('tools'))
      }, tools && /*#__PURE__*/_react["default"].createElement(_Hidden["default"], {
        xsDown: true
      }, tools.map(function (tool) {
        return /*#__PURE__*/_react["default"].createElement(_AnalyticsWrapper["default"], {
          key: tool.key,
          targetId: tool.key
        }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
          title: tool.title && (0, _i18n.t)(tool.title),
          key: tool.key,
          className: classes.iconHover,
          onClick: tool["function"]
        }, tool.identifier));
      })), /*#__PURE__*/_react["default"].createElement(_Hidden["default"], {
        smUp: true
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
        "aria-label": "Menu",
        "aria-haspopup": "true",
        classes: {
          root: classes.ToolbarButton,
          label: classes.ToolbarIconButton
        },
        onClick: this.handleClick
      }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], null, toolbarMobileIcon)), /*#__PURE__*/_react["default"].createElement(_Menu["default"], {
        id: "long-menu",
        anchorEl: anchorEl,
        open: open,
        getContentAnchorEl: null,
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'center'
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'center'
        },
        onClose: this.handleClose,
        PaperProps: {
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
            width: 250
          }
        }
      }, tools && tools.map(function (tool) {
        return /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
          className: classes.MenuItemOption,
          key: tool.key,
          onClick: _this2.handleClose
        }, /*#__PURE__*/_react["default"].createElement(_AnalyticsWrapper["default"], {
          key: tool.key,
          targetId: tool.key
        }, /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            display: 'flex',
            width: '100%'
          },
          onClick: tool["function"]
        }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
          key: tool.key,
          className: classes.iconHover
        }, tool.identifier), /*#__PURE__*/_react["default"].createElement("div", {
          className: classes.toolTitle
        }, tool.title && (0, _i18n.t)(tool.title)))));
      })))));
    }
  }]);
  return ToolbarList;
}(_react["default"].Component);
var _default = exports["default"] = (0, _styles.withStyles)(styles, {
  name: 'ToolbarList'
})(ToolbarList);